import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { AdvertiserSectorCreationFormComponent } from '../../components/advertiser-sector-creation-form/advertiser-sector-creation-form.component';
import { Tag } from '~core/models/tag.models';

@Component({
  selector: 'advertiser-sector-creation-dialog',
  standalone: true,
  imports: [AdvertiserSectorCreationFormComponent],
  templateUrl: './advertiser-sector-creation-dialog.component.html',
  styleUrl: './advertiser-sector-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertiserSectorCreationDialogComponent extends BaseComponent {
  sector = input<Tag>();
}
